// Query Param keys
export const CLIENT_ID_FULL_PARAM_KEY = 'clientid';
export const CLIENT_ID_SHORT_PARAM_KEY = 'c';
export const ORIGIN_CHANNEL_PARAM_KEY = 'o';
export const STRATEGY_PARAM_KEY = 'r';
export const LANGUAGE_PARAM_KEY = 'l';
export const SITE_CODE_PARAM_KEY = 'sc';
export const D2D_TOKEN_PARAM_KEY = 'd';
